import { TreePillsInput, TreePillsInputProps } from "./tree/tree-pills-input"
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"
import { Empty } from "../@client/Theasoft_ApiServer__Utils_TreeBase"

export interface ContractTypeTreeSelectProps
  extends Omit<TreePillsInputProps<Empty>, "tree"> {}

export function ContractTypeTreeSelect(props: ContractTypeTreeSelectProps) {
  const { data } = useSuspenseQueryGet(
    "/api/ContractType/GetContractTypeTree",
    null
  )
  return <TreePillsInput {...data} {...props} />
}
